// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1iFK8","location":"Header_location__2wGJD"};